import { ApiClient } from '@webapp/core/services/ApiClient'
import { createLocalStorage } from '@webapp/core/services/LocalPersistentStorage'
import { ConversationRepository } from './ConversationRepository'
import { GlobalSearchRecentsRepository } from './GlobalSearchRecentsRepository'
import { GlobalSearchRepository } from './GlobalSearchRepository'
import { GuidedIntakePromoDismissalRepository } from './GuidedIntakePromoDismissalRepository'
import { RecentConversationsRepository } from './RecentConversationsRepository'

export const globalSearchRecentsRepository = new GlobalSearchRecentsRepository({
  storage: createLocalStorage({ defaultTTL: null }),
})

export const recentConversationsRepository = new RecentConversationsRepository({
  storage: createLocalStorage({ defaultTTL: null }),
})

export const guidedIntakePromoDismissalRepository =
  new GuidedIntakePromoDismissalRepository({
    storage: createLocalStorage({ defaultTTL: null }),
  })

export const globalSearchRepository = new GlobalSearchRepository({
  httpClient: ApiClient,
})

export const conversationRepository = new ConversationRepository({
  httpClient: ApiClient,
  loadA2uiClientCapabilities: () =>
    import('../../value-objects/A2uiCatalog').then((catalog) =>
      catalog.getA2uiClientCapabilities()
    ),
})
